import { AppThunk } from '../../../store/rootReducer';
import * as ecgClient from '../../ecg/clients/ecg.client';
import { HolterStripPayload } from '../../ecg/types/ecg.type';
import { QrsOnset } from '../../ecg/types/qrs-onset.type';
import { HOUR } from '../../utils/time';
import * as scatterActions from '../actions/scatter.actions';

export const loadStripOnsets =
  (stripInfo?: HolterStripPayload): AppThunk =>
  async (dispatch) => {
    if (stripInfo == null) {
      dispatch(scatterActions.load({ onsets: [], meta: { history: false } }));
      return;
    }

    const currentHour = Math.round(stripInfo.start / HOUR);
    const previousHour = currentHour - 1;
    const nextHour = currentHour + 1;

    const [firstBatch, secondBatch, thirdBatch] = await Promise.all([
      ecgClient.getQrsOnsets(stripInfo.parentId, previousHour),
      ecgClient.getQrsOnsets(stripInfo.parentId, currentHour),
      ecgClient.getQrsOnsets(stripInfo.parentId, nextHour),
    ]);

    let onsets: QrsOnset[] = [];
    if (firstBatch != null) {
      onsets = onsets.concat(firstBatch);
    }
    if (secondBatch != null) {
      onsets = onsets.concat(secondBatch);
    }
    if (thirdBatch != null) {
      onsets = onsets.concat(thirdBatch);
    }

    dispatch(scatterActions.load({ onsets, meta: { history: false } }));
  };
